import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  activeRequests = 0;

  // URLs for which the loading screen should not be enabled
  /*skipUrls = [
    '/assets'
  ];*/
  skipUrls = [];

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let displayLoading = false;


    displayLoading = true;


    for (const skipUrl of this.skipUrls) {
      if (new RegExp(skipUrl).test(request.url)) {
        displayLoading = false;
        break;
      }
    }

    const spinnerDisabled = Number(localStorage.getItem('spinnerDisabled'));
    if (spinnerDisabled > 0) {
      displayLoading = false;
      localStorage.setItem('spinnerDisabled', (spinnerDisabled - 1).toString());
    }

    if (!displayLoading) {
      return next.handle(request);
    }
    if (!request.params.get('video')) {
      request.params.delete('video')
      this.loadingService.startLoading();
    }


    if (request.url.includes('/logintoken')) {
      document.documentElement.style.setProperty('--spinner-bg-color', 'white');
    } else {
      document.documentElement.style.setProperty('--spinner-bg-color', 'rgba(255, 255, 255, 0.77)');
    }

    this.activeRequests++;

    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests === 0) {
          this.loadingService.stopLoading();
        }
      })
    );
  }

}
